export enum BrowserMessages {
  Signup_Complete = 'Signup_Complete',
  Signup_Complete_Button_Close = 'Signup_Complete_Button_Close',

  Bank_Unresponsive = 'Bank_Unresponsive',

  Submitted_Consents = 'Submitted_Consents',
  Consents_Shown = 'Consents_Shown',

  Submitted_Bank_Details = 'Submitted_Bank_Details',
  Submitted_Consents_Details = 'Submitted_Consents_Details',
  Submitted_Consents_Security = 'Submitted_Consents_Security',

  Timeout = 'Timeout',
  Retrieving_Transactions = 'Retrieving_Transactions',

  Oauth_Successful = 'Oauth_Successful',
  Oauth_Unsuccessful = 'Oauth_Unsuccessful',
  Valid_Credentials = 'Valid_Credentials',
  Invalid_Credentials = 'Invalid_Credentials',
  Bank_Cancelled = 'Bank_Cancelled',

  Retry_Required = 'Retry_Required',

  Selected_Bank = 'Selected_Bank',
  System_Error = 'System_Error',

  Close_iFrame = 'Close_iFrame',

  Account_Locked = 'Account_Locked',
  Receipt_Shown = 'Receipt_Shown',
  Start_Polling = 'Start_Polling',
  PDF_Uploaded = 'PDF_Uploaded',
  Got_MFA = 'Got_MFA',
  PDFUpload_Failed = 'PDFUpload_Failed',
  PDFSignup_Complete = 'PDFSignup_Complete',
  Signup_Finished = 'Signup_Finished',
  Consent_Cancelled = 'Consent_Cancelled',
  Consent_Void = 'Consent_Void',
}

export const notifyParent = (data: BrowserMessages) => {
  try {
    window.top.postMessage(data, '*');
    if (window.top !== window.parent)
    {
      window.parent.postMessage(data, '*');
    }
  } catch (e) {
    // console.log('errorrorr');
    // throw e;
    return;
  }
};

export const signupComplete = () => notifyParent(BrowserMessages.Signup_Complete);
export const signupCompleteButtonClose = () => notifyParent(BrowserMessages.Signup_Complete_Button_Close);
export const systemError = () => notifyParent(BrowserMessages.System_Error);
export const selectBank = () => notifyParent(BrowserMessages.Selected_Bank);
export const consentShown = () => notifyParent(BrowserMessages.Consents_Shown);
export const consentDetails = () => notifyParent(BrowserMessages.Submitted_Consents_Details);
export const consentSecurity = () => notifyParent(BrowserMessages.Submitted_Consents_Security);
export const validCredentials = () => notifyParent(BrowserMessages.Valid_Credentials);
export const bankCancelled = () => notifyParent(BrowserMessages.Bank_Cancelled);
export const signupFinished  = () => notifyParent(BrowserMessages.Signup_Finished);
export const consentCancelled = () => notifyParent(BrowserMessages.Consent_Cancelled);
export const consentVoid = () => notifyParent(BrowserMessages.Consent_Void);
